import cprValidator from 'foundation/js/inputValidators/cprValidator'
import emailValidator from 'foundation/js/inputValidators/emailValidator'
import isBoolean from 'foundation/js/inputValidators/isBoolean'
import nameValidator from 'foundation/js/inputValidators/nameValidator'

export default [
    {
        name: 'firstName',
        value: '',
        isValid: false,
        validator: nameValidator
    },
    {
        name: 'lastName',
        value: '',
        isValid: false,
        validator: nameValidator
    },
    {
        name: 'email',
        value: '',
        isValid: false,
        validator: emailValidator
    },
    {
        name: 'isAnonymous',
        value: false,
        isValid: false,
        validator: isBoolean
    },
    {
        name: 'taxDeduction',
        value: false,
        isValid: false,
        validator: isBoolean
    },
    {
        dependentField: 'taxDeduction',
        dependentFieldValue: false,
        dependentFieldValidator: (value) => value === false,
        name: 'cpr',
        value: '',
        isValid: false,
        validator: cprValidator
    }
]
